module.exports = __webpack_public_path__ + "media/images/profile/1-ff078d68c301287af3230b4f6c1c272d.jpg";